module.exports = __webpack_public_path__ + "img/Checklist.13128956.svg";